import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatSort, Sort} from '@angular/material/sort';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {FormControl} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {TableControl} from '../../../../../common/models/TableControl';
import {DateUtil} from '../../../../../common/util/DateUtil';
import {PagedRequestDTO} from '../../../../../common/models/PagedRequestDTO';
import {DisplayIcon} from 'src/app/modules/common/components';
import {
  ConfirmationDialogComponent
} from '../../../../../common/dialogs/confirmation-dialog/confirmation-dialog.component';
import {detailsExpand} from '../../../../../common';
import {IngredientService} from '../../../../services/ingredient.service';
import {IngredientDTO} from '../../../../models/IngrdientDTO';
import {createFieldMap, getSortDirection} from '../../../../../common/util/Util';
import {SharedService} from '../../../../../common/services/shared-service';
import {EntityTable} from '../../../../../common/types/entity-table.enum';

@Component({
  selector: 'app-ingredients',
  templateUrl: './ingredients.component.html',
  styleUrls: [
    '../../../../../../../styles/global/_management-styles.scss'
  ],
  animations: [detailsExpand]
})
export class IngredientsComponent implements OnInit, AfterViewInit {
  readonly DisplayIcon = DisplayIcon;

  ingredientFormControl: FormControl;
  ingredientDisplayedColumns: string[] = [
    'icons',
    'ingredientId',
    'name',
    'pubchemName',
    'source'
  ];
  ingredientDataSource: IngredientDTO[];
  ingredientExpandedRow: IngredientDTO | null;
  ingredientTableControl: TableControl;

  isConfirmed = false;
  dateFormat = DateUtil.dateFormat;
  dateTimeFormat = DateUtil.dateTimeFormat;
  length = 100;
  pageSize = 10;
  pageNumber = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];

  @ViewChild('matSort', {static: false}) tableSort: MatSort;
  @ViewChild('ingredientSort', {static: false}) ingredientSort: MatSort;
  @ViewChild('ingredientPaginator', {static: false}) ingredientPaginator: MatPaginator;
  @ViewChild('ingredientSearch') private ingredientSearch: ElementRef;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private sharedService: SharedService,
    private ingredientService: IngredientService,
  ) {
    this.ingredientFormControl = new FormControl('');
    this.ingredientTableControl = new TableControl(
      this.length,
      this.pageSize,
      this.pageNumber,
      this.pageSizeOptions,
      'ingredientId',
      'desc',
      'name',
      ''
    );
  }

  ngOnInit(): void {
    this.getListOfIngredients(this.ingredientTableControl);
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.ingredientSearch.nativeElement.focus(), 0);
  }

  getListOfIngredients(tableControl: TableControl): void {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblIngredient;
    pagedRequestDTO.pageNumber = tableControl.pageNumber;
    pagedRequestDTO.pageSize = tableControl.pageSize;
    pagedRequestDTO.sortField = tableControl.sortField;
    pagedRequestDTO.sortDirection = getSortDirection(
      tableControl.sortDirection
    );
    pagedRequestDTO.fieldMap = createFieldMap(
      tableControl.filterField,
      tableControl.filterValue
    );

    this.ingredientService.getListOfIngredients(pagedRequestDTO).subscribe(
      (response) => {
        this.ingredientDataSource = response.resultList;
        this.ingredientTableControl.length = response.totalRecords;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  pageChanged($event: PageEvent) {
    this.ingredientTableControl.pageNumber = $event.pageIndex;
    this.ingredientTableControl.pageSize = $event.pageSize;
    this.getListOfIngredients(this.ingredientTableControl);
  }

  sortData($event: Sort) {
    if (this.ingredientPaginator != null) {
      this.ingredientPaginator.firstPage();
    }
    this.ingredientTableControl.pageNumber = 0;
    this.ingredientTableControl.sortField = $event.active;
    this.ingredientTableControl.sortDirection = $event.direction;
    this.getListOfIngredients(this.ingredientTableControl);
  }

  onInputChangedFilterData(filterField: string) {
    if (this.ingredientPaginator != null) {
      this.ingredientPaginator.firstPage();
    }
    this.ingredientTableControl.pageNumber = 0;
    this.ingredientTableControl.filterField = filterField;
    this.ingredientTableControl.filterValue = this.ingredientFormControl.value;
    this.getListOfIngredients(this.ingredientTableControl);
  }

  deleteEntry(event: MouseEvent, id: number) {
    event.preventDefault();
    event.stopPropagation();

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '40vw',
      data: 'Are you sure you wish to delete this entity?'
    });

    dialogRef.afterClosed().subscribe((result) => {
      const isConfirmed = result;

      if (isConfirmed) {
        this.ingredientService.deleteIngredient(id).subscribe(
          () => {
            this.sharedService.openSnackBar(`Ingredient ${id} deleted`, 'Dismiss');
            this.getListOfIngredients(this.ingredientTableControl);
          },
          (errorResponse) => {
            const error = errorResponse.error;
            this.sharedService.openErrorDialog(error.businessMessage);
          }
        );
      }
    });
  }

  editEntry(event: MouseEvent, id: number) {
    event.preventDefault();
    event.stopPropagation();

    this.router.navigate(['/pharmacy-management/edit-ingredient/' + id]);
  }

}
